import type { RouteRecordRaw } from "vue-router";
import Layout from "@/views/layouts/index.vue";

const followRouter: RouteRecordRaw[] = [
    {
        path: "/followCenter",
        name: "FollowCenter",
        meta: { title: "关注中心" },
        component: Layout,
        redirect: "/followCenter/footprints",
        children: [
            {
                path: "footprints",
                name: "Footprints",
                meta: { title: "我的足迹" },
                component: () => import("@/views/pages/follow/footprints/index.vue")
            },
            {
                path: "favorite",
                name: "Favorite",
                meta: { title: "我的收藏" },
                component: () => import("@/views/pages/follow/favorite/index.vue")
            },
            {
                path: "interest",
                name: "Interest",
                meta: { title: "我的关注" },
                component: () => import("@/views/pages/follow/interest/index.vue")
            }
        ]
    }
];

export default followRouter;
